module.exports = __webpack_public_path__ + "static/a-xx-117-art-547206608630cebf0881eac6cf0b50b0.jpg";